module.exports = __webpack_public_path__ + "img/jietu2.43eaca66.png";